import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";

const Dimension2AutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label = "Dimension 2", load = true, disabled = false, infoText, error, helperText}) => {
    return (
        <AsyncAutoCompleteContained
            label={label}
            url="/autocompleteApi/Dimension2"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={ disabled}

        />
    );
};

export default Dimension2AutoComplete;
